exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-36572696] .el-form-item{margin-bottom:20px}[data-v-36572696] .el-form-item__content{-webkit-box-flex:1;-ms-flex:1;flex:1}.select-bar[data-v-36572696]{display:-webkit-box;display:-ms-flexbox;display:flex}[data-v-36572696] .el-cascader{width:100%}\n", ""]);

// exports
